import { Form, Input, Typography, Space } from "antd";
import React from "react";
import { FileTextOutlined, AuditOutlined } from "@ant-design/icons";

const sectionStyle = {
  background: "#FAFBFC",
  border: "1px solid #F2F4F7",
  borderRadius: 8,
  padding: 16,
  marginBottom: 12,
};

const ReviewNotes = ({ onValuesChange, formData }) => {
  return (
    <Form
      id="review-notes"
      onValuesChange={(cur, all) => onValuesChange("review_notes", all)}
      layout="vertical"
      className="ip-forms"
      initialValues={formData?.review_notes}
    >
      <div style={sectionStyle}>
        <Space style={{ marginBottom: 8 }}>
          <FileTextOutlined style={{ color: "#98A2B3" }} />
          <Typography.Text strong>Progress Notes</Typography.Text>
        </Space>
        <Form.Item name={"progress_notes"} style={{ marginBottom: 0 }}>
          <Input.TextArea
            rows={4}
            placeholder="Document patient progress, functional improvements, and therapy response..."
          />
        </Form.Item>
      </div>
      <div style={sectionStyle}>
        <Space style={{ marginBottom: 8 }}>
          <AuditOutlined style={{ color: "#98A2B3" }} />
          <Typography.Text strong>Review Notes</Typography.Text>
        </Space>
        <Form.Item name={"review_notes"} style={{ marginBottom: 0 }}>
          <Input.TextArea
            rows={4}
            placeholder="Clinical review observations, plan adjustments, and follow-up notes..."
          />
        </Form.Item>
      </div>
    </Form>
  );
};

export default ReviewNotes;
